import type { CalendarSettings } from "../types";

export type CalendarConnection = {
  /** True if the user has at least one linked calendar (from user_external_services). */
  hasCalendar: boolean;
  /** First linked source (e.g. "google") or null. Use for routing and "primary" calendar type. */
  primarySource: string | null;
};

/**
 * Derives "has calendar" and primary source from calendar settings.
 * Use this (or useCalendarConnection) instead of reading userSettings.calendarType/calendarId.
 *
 * @param settings - Result of GET /user/settings/calendar (or useCalendarSettings().data)
 * @returns { hasCalendar, primarySource }
 */
export function getCalendarConnection(
  settings: CalendarSettings | undefined
): CalendarConnection {
  if (!settings) {
    return { hasCalendar: false, primarySource: null };
  }
  const hasCalendar = settings.hasCalendar && settings.linkedSources.length > 0;
  const primarySource = hasCalendar ? settings.linkedSources[0] ?? null : null;
  return { hasCalendar, primarySource };
}
